<template>
  <div class="container-fluid mt-5">
    <card class="no-border-card" footer-classes="pb-2">
      <template slot="header">
        <h3 class="mb-0">
          <i class="fa fa-graduation-cap text-primary mr-2"></i>
          {{
            $t("TRAININGS.HELP_FOR", {
              topic: $t("TRAININGS.CONTEXT_INVENTORY"),
            })
          }}
        </h3>
      </template>

      <div v-if="loading" class="text-center py-4">
        <img src="/img/loading.gif" style="height: 80px; width: 80px" />
      </div>
      <training-files-panel v-else :files="files" />
    </card>
  </div>
</template>

<script>
import TrainingFilesPanel from "@/components/Trainings/TrainingFilesPanel.vue";
import { HELP_CONTEXT_INVENTORY } from "@/constants/helpContexts";

/**
 * Onglet « Formation » du module Inventaire : impression de l'inventaire depuis
 * l'entrepôt et saisie par mouvement de stock (demande de la coordonnatrice aux
 * achats, 2026-10-09).
 */
export default {
  layout: "DashboardLayout",

  components: { TrainingFilesPanel },

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    files() {
      return this.$store.getters["trainings/helpForContext"](
        HELP_CONTEXT_INVENTORY
      );
    },
  },

  async created() {
    try {
      await this.$store.dispatch("trainings/helpForContext", {
        context: HELP_CONTEXT_INVENTORY,
      });
    } catch (error) {
      this.$notify({
        type: "danger",
        message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
      });
    }
    this.loading = false;
  },
};
</script>
